import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface InstallmentOptionsState {
  isOpen: boolean;
}
const initialState: InstallmentOptionsState = {
  isOpen: false
};

const installmentOptionsSlice = createSlice({
  name: 'installmentOptions',
  initialState,
  reducers: {
    setInstallmentOptionsOpen(state, action: PayloadAction<boolean>) {
      state.isOpen = action.payload;
    },
    setInstallmentOptionsClose(state) {
      state.isOpen = false;
    }
  }
});

export const { setInstallmentOptionsOpen, setInstallmentOptionsClose } =
  installmentOptionsSlice.actions;
export default installmentOptionsSlice.reducer;
